import IdeyaModal from '../../../../../common/antd/ideya-modal.tsx'
import IdeyaTypography from '../../../../../common/antd/ideya-typography.tsx'
import { useUpdateBlockLeaveMutation } from '../../../../../apis/block-leave/block-leave-api.api.ts'
import { IdeyaSpinner } from '../../../../../common/components/ideya-spinner.tsx'
import { useTranslation } from 'react-i18next'

interface UserChangeLiquidateModalProps {
  showChangeLiquidateModal: boolean
  blockLeaveId: string | null
  liquidateValue: boolean
  handleCancel: () => void
}

export const UserChangeLiquidateModal: React.FC<
  UserChangeLiquidateModalProps
> = ({
  showChangeLiquidateModal,
  blockLeaveId,
  liquidateValue,
  handleCancel,
}) => {
  const { t } = useTranslation()
  const [updateBlockLeave, { isLoading }] = useUpdateBlockLeaveMutation()

  const onFinish = async () => {
    await updateBlockLeave({
      id: blockLeaveId ?? '',
      closeIdeas: liquidateValue,
    })
    handleCancel()
  }

  return (
    <IdeyaModal
      open={showChangeLiquidateModal}
      title={t(
        'user_management.user_modal.change_liquidate_modal.change_liquidate'
      )}
      destroyOnClose
      onCancel={handleCancel}
      onOk={onFinish}
    >
      {isLoading ? (
        <IdeyaSpinner />
      ) : (
        <IdeyaTypography.Text>
          {t(
            'user_management.user_modal.change_liquidate_modal.are_you_sure_change_setting'
          )}
        </IdeyaTypography.Text>
      )}
    </IdeyaModal>
  )
}
